import React from 'react';
import { Table } from 'react-bootstrap';
import { PageLoader } from '../../../../../Components/NoDataFoundTable/NoDataFoundTable';

const DatasetViewerTableView = ({
  processing,
  tableRef,
  isFullScreen,
  showSrColumn,
  srColumnLabel,
  visibleColumns,
  columns,
  sorts,
  handleSort,
  openContextMenu,
  getHeaderMenuItems,
  getWidth,
  showLabels,
  colType,
  LABELS,
  pageRows,
  startIndex,
  data,
  selectedRow,
  setSelectedRow,
  onRowClick,
  onCellClick,
  getCellMenuItems,
  onResizeMouseDown,
  autoFit,
  frozen,
  clearColFilter,
  visibleColumnsLength,
  esc,
  highlight,
  showRowDetails
}) => {
  if (processing) {
    return (
      <div style={{ alignItems: 'center', justifyContent: 'center' }}>
        <PageLoader />
      </div>
    );
  }

  return (
    <Table ref={tableRef} className="m-0 custom-table w-auto" hover striped bordered>
      <thead className="position-sticky top-0 z-1">
        <tr>
          {showSrColumn && (
            <th
              style={{
                width: 45,
                minWidth: 45,
                maxWidth: 45,
                position: frozen > 0 ? 'sticky' : 'static',
                left: 0,
                zIndex: frozen > 0 ? 5 : 1,
                background: '#f8f9fa'
              }}
              className="text-center position-relative"
            >
              {srColumnLabel}
            </th>
          )}
          {visibleColumns.map((col, idx) => {
            const ci = columns.indexOf(col);
            const lbl = showLabels ? (LABELS[col] || col) : col;
            const si = sorts.findIndex(s => s.col === ci);
            const mark = si >= 0 ? (
              <span className="text-success ms-1">
                {sorts[si].dir === 'asc' ? '▲' : '▼'}
                {sorts.length > 1 && <sub style={{ fontSize: '8px' }}>{si + 1}</sub>}
              </span>
            ) : '';
            const w = getWidth(col);
            const isFrozen = idx < frozen;
            return (
              <th
                key={col}
                style={{
                  width: w,
                  minWidth: w,
                  maxWidth: w,
                  position: isFrozen ? 'sticky' : 'static',
                  left: isFrozen ? (showSrColumn ? 45 + visibleColumns.slice(0, idx).reduce((acc, c) => acc + getWidth(c), 0) : visibleColumns.slice(0, idx).reduce((acc, c) => acc + getWidth(c), 0)) : 'auto',
                  zIndex: isFrozen ? 4 : 1,
                  background: '#f8f9fa'
                }}
                className="position-relative"
              >
                <span
                  className="cursor-pointer"
                  onClick={(e) => handleSort(ci, e.shiftKey || e.ctrlKey || e.metaKey)}
                  title={`${col} (${colType(col)}) — click to sort, right-click for menu`}
                >
                  {lbl} {mark}
                </span>
                <span className="ms-1 cursor-pointer" onClick={(e) => openContextMenu(e, getHeaderMenuItems(col, ci))} title="Column menu">▾</span>
                <div
                  className="position-absolute top-0 end-0"
                  style={{ width: '6px', height: '100%', cursor: 'col-resize', zIndex: 3 }}
                  onMouseDown={(e) => onResizeMouseDown(e, col)}
                  onDoubleClick={() => autoFit(col)}
                  title="Drag to resize · double-click to auto-fit"
                />
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {pageRows.length === 0 ? (
          <tr>
            <td colSpan={visibleColumnsLength + (showSrColumn ? 1 : 0)} className="text-center text-muted py-3">
              {visibleColumns.length === 0 ? 'All columns hidden. Use Columns → Select All.' : 'No records match the current filter or search.'}
            </td>
          </tr>
        ) : (
          pageRows.map((row, rowIndex) => {
            const absIndex = data.indexOf(row);
            return (
              <tr
                key={rowIndex}
                onClick={() => {
                  setSelectedRow(absIndex);
                  onRowClick && onRowClick(row, absIndex);
                }}
                style={{ cursor: onRowClick ? 'pointer' : 'default' }}
              >
                {showSrColumn && (
                  <td
                    className="text-center"
                    style={{
                      position: frozen > 0 ? 'sticky' : 'static',
                      left: 0,
                      zIndex: frozen > 0 ? 2 : 1
                    }}
                  >
                    {startIndex + absIndex + 1}
                  </td>
                )}
                {visibleColumns.map((col, idx) => {
                  const raw = row.fieldRow[col];
                  const miss = (raw == null || String(raw).trim() === '');
                  const w = getWidth(col);
                  const isFrozen = idx < frozen;
                  return (
                    <td
                      key={col}
                      className={miss ? 'text-muted' : ''}
                      style={{
                        width: w,
                        minWidth: w,
                        maxWidth: w,
                        position: isFrozen ? 'sticky' : 'static',
                        left: isFrozen ? (showSrColumn ? 45 + visibleColumns.slice(0, idx).reduce((acc, c) => acc + getWidth(c), 0) : visibleColumns.slice(0, idx).reduce((acc, c) => acc + getWidth(c), 0)) : 'auto',
                        zIndex: isFrozen ? 2 : 1
                      }}
                      title={String(raw == null ? '' : raw)}
                      onDoubleClick={() => showRowDetails(row, data.indexOf(row))}
                      onContextMenu={(e) => openContextMenu(e, getCellMenuItems(row, col))}
                      onClick={(e) => onCellClick && onCellClick(row, col, absIndex, e)}
                    >
                      {miss ? '' : String(raw)}
                    </td>
                  );
                })}
              </tr>
            );
          })
        )}
      </tbody>
    </Table>
  );
};

export default DatasetViewerTableView;
